import { createSlotRecipe } from './runtime.js';

const inputConfig = {"name":"input","slots":["root","inputContainer","input","startAdornment","endAdornment"],"defaultVariants":{"error":false,"fullWidth":false,"ghost":false,"size":"md","success":false,"warning":false},"variantMap":{"error":["true"],"fullWidth":["true"],"ghost":["true"],"size":["lg","md","sm","xl","xs"],"success":["true"],"warning":["true"]}}

export const input = /* @__PURE__ */ createSlotRecipe(inputConfig)